module.exports = __webpack_public_path__ + "statics/img/cross.c76eecb4.svg";